module.exports = __webpack_public_path__ + "img/logo.732e81b0.png";